// cSpell: ignore putaoid, Yuanti, Unmount

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import utils from '../../lib/utils';
import request from '../../lib/request';
import { COURSE_TYPE } from '../../lib/components/LessonPath/static/json/constant';

import { reqAPI } from '../../server/reqAPI';
import { abnormalReporting } from '../../server/commonFun';
import { Flex, LessonTag, EllipsisTwoCell } from '../../lib/components/LessonPath/static/style';


export default class AllCourse extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allCourseData: null,
        };

        this.onScrollHandler = this.onScrollHandler.bind(this);
        this.special = utils.getQueryString("special");
    }

    componentDidMount() {
        const that = this;

        this.getLevelCourseHandler();
        window.addEventListener('mousewheel', that.onScrollHandler);
        window.addEventListener('DOMMouseScroll', that.onScrollHandler);
    }

    componentWillUnmount() {
        const that = this;
        window.removeEventListener('mousewheel', that.onScrollHandler);
        window.removeEventListener('DOMMouseScroll', that.onScrollHandler);
    }

    // 滚动触发的事件监听
    onScrollHandler() {
        this.lazyLoadShowImg();
    }

    // 获取当前 level 的所有数据
    getLevelCourseHandler() {
        const that = this;
        const { level } = this.props;

        request(reqAPI.all_level, Object.assign({}, this.context.user, { level }), { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code && res.code === 200) {
                    this.setState({ allCourseData: res.data ? res.data : null }, () => {
                        setTimeout(() => {
                            that.lazyLoadShowImg();
                        }, 500);
                    });
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.all_level,
                        type: 'data',
                        res
                    });
                }
            })
            .catch(err => {
                abnormalReporting({
                    putaoid: this.context.user.putaoid,
                    url: reqAPI.all_level,
                    type: 'request',
                    err
                });
            });
    }

    // 懒加载显示图片
    lazyLoadShowImg() {
        const imgArr = document.getElementsByClassName("lazy-load");

        for (let i = 0; i < imgArr.length; i++) {
            const elementTop = imgArr[i].getBoundingClientRect().top;
            if (elementTop - this.refs.courseBox.scrollTop < window.innerWidth) {
                // 防止重复获取该图片
                if (imgArr[i].src !== imgArr[i].dataset.src) {
                    imgArr[i].src = imgArr[i].dataset.src;
                }
            }
        }
    }

    render() {
        const { allCourseData } = this.state;

        return (
            <CourseBox ref='courseBox'>
                <CourseContent>
                    {allCourseData && Array.isArray(allCourseData) && allCourseData.map((value, index) =>
                        <CourseUnit key={`unit-${index}`}>
                            <UnitNum>{"Unit-" + (index + 1)} {value.unitName}</UnitNum>
                            {value && value.lessons && Array.isArray(value.lessons) && value.lessons.map((item, indexLesson) =>
                                <CourseLesson
                                    key={`lesson-${indexLesson}`}
                                    onClick={() => this.props.allCourseChangeUnitHandler(index + 1, item.cid)}
                                >
                                    {item.lessonTag &&
                                        <Tag
                                            type={indexLesson + 1}
                                            long={(item.type === COURSE_TYPE.ctLesson || item.type === COURSE_TYPE.expandLesson) ? true : false}
                                        >
                                            {item.lessonTag}
                                        </Tag>
                                    }
                                    <Picture alt=""
                                        className='lazy-load'
                                        data-src={item.image ? item.image : ""}
                                        src={`${require("../../static/img/path/img-placeholder.png")}`}
                                    />
                                    <LessonNumber>
                                        {
                                            !this.special ?
                                                ("Unit " + (index + 1) + "-")
                                                :
                                                null
                                        }Lesson {indexLesson + 1}
                                    </LessonNumber>
                                    <LessonTitle>
                                        <EllipsisTwoCell>{item.title}</EllipsisTwoCell>
                                    </LessonTitle>
                                </CourseLesson>
                            )}
                        </CourseUnit>
                    )
                    }
                </CourseContent>
            </CourseBox>
        );
    }
}

AllCourse.contextTypes = {
    user: PropTypes.object
}

const CourseBox = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
        
    >div:nth-child(1) {
        margin-top: 1rem;
    }
`;

const CourseContent = styled.div`
    width: 19.6rem;
    max-width: 100%;
    margin: 0 auto;
`;

const CourseUnit = styled(Flex)`
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 0.91rem;
`;

const UnitNum = styled.div`
    width: 100%;
    font-size: 0.25rem;
    line-height: 0.36rem;
    text-align: center;
`;

const CourseLesson = styled.div`
    position: relative;
    flex: none;
    width: 2.06rem;
    height: 2.17rem;
    border-radius: 0.16rem;
    background: #fff;
    margin: 0.19rem 0.19rem;
    padding: 0.11rem;
    cursor: pointer;
`;

const Tag = styled(LessonTag)`
    height: 0.32rem;
    font-size: 0.16rem;
    line-height: 0.32rem;
`;

const Picture = styled.img`
    display: block;
    flex: none;
    width: 100%;
    height: 1.07rem;
    border-radius: 0.11rem;
`;

const LessonNumber = styled.div`
    color: #9187A0;
    font-size: 0.17rem;
    line-height: 0.27rem;
    text-align: center;
    margin-top: 0.08rem;
`;

const LessonTitle = styled(Flex)`
    justify-content: center;
    align-items: center;
    font-family: STYuanti-SC-Regular,STYuanti-SC;
    font-weight: 400;
    height: 0.45rem !important;
    font-size: 0.21rem;
    line-height: 0.27rem;
    text-align: center;
    margin: 0.11rem auto;
`;


// WEBPACK FOOTER //
// ./src/components/lesson-path/all-course.js